import { FieldsForProductInfo } from "../view-models/FieldsForProductInfo";
import { ProductFieldInfoVisibility } from "../view-models/ProductFieldInfoVisibility";

export class GffpHelper {
    static filterRequiredAndOptionalFields(fieldsForProductInfo: FieldsForProductInfo) {
        const a = fieldsForProductInfo.productFieldInfos?.filter((field: any) => field.visibility === ProductFieldInfoVisibility.REQ || field.visibility === ProductFieldInfoVisibility.OPT);

        return a;
    }
}